import { render, staticRenderFns } from "./EditorMarkdownIt.vue?vue&type=template&id=4d187351"
import script from "./EditorMarkdownIt.vue?vue&type=script&lang=js"
export * from "./EditorMarkdownIt.vue?vue&type=script&lang=js"
import style0 from "./EditorMarkdownIt.vue?vue&type=style&index=0&id=4d187351&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports